import { AuthorRole } from './AuthorRole'

export default class ProAuthor extends AuthorRole {
  maxParticipantsPerArc = 50
  maxRunningArcs = 3
  canCreatePrivateArcs = true
  canHaveVIPTeamMembers = true
  canCreateAudioBookArcs = true
  canScheduleArcs = true
  canLimitReviewersToAllOnSeries = true
  canIdentifyPiracy = true
  canRequireReviewOnPreviousBooksInSeries = true
  canShowSocialLinksOnAuthorPages = true
}
